export default __webpack_public_path__ + "static/media/Etape8_TimescopeTellieres_Before_Filtre.e742f129.jpg";